var map = {
  "./modules_icons/accounting.png": "26642",
  "./modules_icons/asset.png": "26561",
  "./modules_icons/assets.png": "25950",
  "./modules_icons/crm.png": "45933",
  "./modules_icons/dist.png": "14937",
  "./modules_icons/expenses.png": "81578",
  "./modules_icons/fi_control.png": "92644",
  "./modules_icons/fm.png": "85874",
  "./modules_icons/hcm.png": "76865",
  "./modules_icons/inventory.png": "6065",
  "./modules_icons/mrp.png": "97158",
  "./modules_icons/operations.png": "23391",
  "./modules_icons/pos.png": "9027",
  "./modules_icons/project.png": "55986",
  "./modules_icons/purchase.png": "99744",
  "./modules_icons/reporting.png": "88699",
  "./modules_icons/sales.png": "93841",
  "./modules_icons/scm.png": "27942"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52411;
